export default function Datenschutz() {
  return (
    <div data-testid="datenschutz-page" className="pt-32 pb-24">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <div className="text-xs uppercase tracking-[0.3em] text-stone-500 mb-6">Rechtliches</div>
        <h1 className="font-heading text-4xl sm:text-5xl font-light tracking-tight mb-12">Datenschutzerklärung</h1>

        <div className="text-stone-700 space-y-8 text-[15px] leading-relaxed">
          <section>
            <h2 className="font-heading text-xl font-medium text-[#1C1C1C] mb-3">1. Datenschutz auf einen Blick</h2>
            <p>
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was
              mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website
              besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie
              persönlich identifiziert werden können.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium text-[#1C1C1C] mb-3">2. Verantwortliche Stelle</h2>
            <p>
              Linea Bodendesign<br />
              Weserstr. 133, 32457 Porta Westfalica<br />
              E-Mail: info@linea-boden-design.de
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium text-[#1C1C1C] mb-3">3. Kontaktformular</h2>
            <p>
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden
              Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort
              angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für
              den Fall von Anschlussfragen bei uns gespeichert.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium text-[#1C1C1C] mb-3">4. Ihre Rechte</h2>
            <p>
              Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Löschung
              oder Einschränkung der Verarbeitung Ihrer gespeicherten Daten,
              ein Widerspruchsrecht gegen die Verarbeitung sowie ein Recht auf
              Datenübertragbarkeit. Bitte kontaktieren Sie uns hierzu unter der
              oben genannten E-Mail-Adresse.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium text-[#1C1C1C] mb-3">5. SSL-Verschlüsselung</h2>
            <p>
              Diese Seite nutzt aus Sicherheitsgründen eine SSL-Verschlüsselung,
              um die Übertragung vertraulicher Inhalte zu schützen.
            </p>
          </section>

          <p className="text-xs text-stone-500 pt-6 border-t border-stone-200">
            Dieser Text ist eine Platzhalter-Vorlage. Bitte vor Veröffentlichung
            durch eine rechtsverbindliche Datenschutzerklärung ersetzen.
          </p>
        </div>
      </div>
    </div>
  );
}
